<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <select2
          v-model="former.PlatformID"
          url="platform"
          labelName="PlatformName"
          placeholder="请选择平台"
          noDataText="没有数据"
        ></select2>&nbsp;
        <el-select v-model="ServerTypes" placeholder="请选择服务器类型" multiple>
          <el-option label="业务" value="1"></el-option>
          <el-option label="数据" value="2"></el-option>
          <el-option label="通讯" value="3"></el-option>
        </el-select>&nbsp;
        <el-input
          clearable
          v-model="former['IP:like']"
          placeholder="搜索服务器IP"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search"></i>
        </el-button>
      </div>
    </div>
    <!-- 数据列 -->
    <el-table size="medium" :data="itemList" v-loading="loading">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      ></el-table-column>
      <el-table-column label="平台名称">
        <template slot-scope="{ row }">{{ row.Platform ? row.Platform.PlatformName : '/' }}</template>
      </el-table-column>
      <el-table-column label="服务器类型">
        <template slot-scope="{ row }">
          <span v-for="type in row.ServerTypes.split(',')" :key="type">
            <el-tag v-if="type === '1'">业务</el-tag>
            <el-tag v-if="type === '2'">数据</el-tag>
            <el-tag v-if="type === '3'">通讯</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="IP" label="服务器IP"></el-table-column>
      <el-table-column prop="HeartBeat" label="在线状态" width="90">
        <template slot-scope="{ row }">
          <span v-if="row.HeartBeat" title="在线">
            <div class="circle-h bg-success"></div>
          </span>
          <span v-else title="离线">
            <div class="circle-h bg-danger"></div>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="CPU使用率" width="250">
        <template slot-scope="{ row }">
          <el-progress
            style="width: 90%"
            :percentage="row.Status && row.Status.CPU
              ? parseFloat((row.Status.CPU.Busy * 100).toFixed(1))
              : 0"
            :color="customColors"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="内存占用率" width="250">
        <template slot-scope="{ row }">
          <el-progress
            style="width: 90%"
            :percentage="row.Status && row.Status.Mem
              ? parseFloat((row.Status.Mem.UsedPercent * 100).toFixed(1))
              : 0"
            :color="customColors"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="磁盘占用率" width="250">
        <template slot-scope="{ row }">
          <el-progress
            style="width: 90%"
            :percentage="row.Status && row.Status.Disk
              ? parseFloat((row.Status.Disk.UsedPercent * 100).toFixed(1))
              : 0"
            :color="customColors"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column width="60" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="onSeeItem(scope.row)" title="详情">
            <i class="fas fa-eye"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paginator">
      <el-pagination
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      itemList: [],
      loading: false,
      former: {
        PlatformID: '',
        'IP:like': '',
      },
      ServerTypes: [],
      customColors: [
        { color: '#92c655', percentage: 40 },
        { color: '#ffa31c', percentage: 80 },
        { color: '#ee4a47', percentage: 100 },
      ],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('serverstatus', {
        params: {
          where: this.former,
          servertypes: this.ServerTypes.toString(),
          with: ['Platform'],
          ...this.pager,
        },
      }).then((response) => {
        this.itemList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
        if (this.pager.page > response.data.last) {
          this.pager.page = response.data.last;
          this.getItemList();
        }
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // item置空
    getEmptyItem() {
      return {
      };
    },
    // 详情
    onSeeItem(row) {
      this.$router.push({ name: 'CpServerStatusDetail', params: { ID: row.ID } });
    },
  },
};
</script>

<style scoped lang="scss">
.circle-h {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: calc(50% - 15px);
}
</style>
